import styled from "@emotion/styled";

export const FormItem = styled.div`
  flex: 1;
  width: 100%;
`;
